export default __webpack_public_path__ + "static/media/html.e4498983.svg";